module.exports = __webpack_public_path__ + "img/bg-09.7d5009eb.jpg";